import React from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'ddc-track-event';
import { useRequestData } from 'wsm-common-data';
import {
	publishVehicleData,
	getVehicleObj
} from '../../../utilities/vehicleTracking';

const VehicleLink = ({ link, uuid, children, tabIndex }) => {
	const { windowId, widgetName } = useRequestData();
	return link ? (
		<a
			href={link}
			tabIndex={tabIndex}
			onClick={() => {
				trackEvent(widgetName, windowId, {
					element: 'Vehicle photo',
					result: 'Navigated to VDP',
					uuid,
					vehicle: getVehicleObj(uuid)
				});
				publishVehicleData(uuid);
			}}
		>
			{children}
		</a>
	) : (
		children
	);
};

export default VehicleLink;

VehicleLink.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
		.isRequired,
	link: PropTypes.string,
	uuid: PropTypes.string.isRequired,
	tabIndex: PropTypes.number
};

VehicleLink.defaultProps = {
	link: '',
	tabIndex: null
};
